"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUint32Binary = exports.connectToBrowserWallet = void 0;
const connectToBrowserWallet = async (walletExtension, hmy, wallet, addrHex, reject) => {
    let userAddress = addrHex;
    if (!userAddress) {
        const { address } = await walletExtension.getAccount();
        userAddress = hmy.crypto.getAddress(address).checksum;
    }
    wallet.defaultSigner = userAddress;
    wallet.signTransaction = async (tx) => {
        try {
            tx.from = userAddress;
            const signTx = await walletExtension.signTransaction(tx);
            return signTx;
        }
        catch (e) {
            reject(e);
        }
        return null;
    };
};
exports.connectToBrowserWallet = connectToBrowserWallet;
const getUint32Binary = (num) => {
    const numBinaryString = Number(num).toString(2);
    const zeroArray = [...new Array(32 - numBinaryString.length)].fill(0);
    return zeroArray.join('') + numBinaryString;
};
exports.getUint32Binary = getUint32Binary;
